import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import './Tooltip.scss';

class TooltipPortal extends Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
        this.portalContainer =
            props.tooltipcontainer && document.getElementById(props.tooltipcontainer)
                ? document.getElementById(props.tooltipcontainer)
                : document.body;
    }

    componentDidMount() {
        this.portalContainer.appendChild(this.el);
    }

    componentWillUnmount() {
        this.portalContainer.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}

class Tooltip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            style: null,
        };

        this.width = this.props.width || 272;
        this.space = this.props.space || 16;
    }

    componentDidMount() {
        this.setVisibility(null, false);
    }

    setVisibility(e, isVisible) {
        const style = { width: this.width };
        const wrapper = this.wrapperElement.getBoundingClientRect();
        const tooltip = this.tooltipElement.getBoundingClientRect();

        if (wrapper.left > window.innerWidth / 2) {
            style.left = wrapper.left + wrapper.width / 2 - this.width * 0.9;
        } else {
            style.left = wrapper.left + wrapper.width / 2 - this.width * 0.1;
        }

        // prevent tooltip from clipping off sides based on space
        style.left = Math.max(this.space, style.left);
        style.left = Math.min(style.left, document.body.clientWidth - this.width - this.space);

        if (wrapper.top < window.innerHeight / 2) {
            // position the tooltip below if the element is in the upper half of the screen
            style.top = wrapper.bottom + window.pageYOffset;
        } else {
            // position the tooltip above if the element is in the lower half of the screen
            style.top = wrapper.top - tooltip.height + window.pageYOffset;
        }

        this.setState({
            visible: isVisible,
            style,
        });
    }

    render() {
        const { className, children, onClick, content, tooltipcontainer } = this.props;
        const { visible } = this.state;

        return (
            <span
                className={classnames(['kmx-tooltip__wrapper', className])}
                onClick={onClick}
                onMouseEnter={(e) => this.setVisibility(e, true)}
                onMouseLeave={(e) => this.setVisibility(e, false)}
                onFocus={(e) => this.setVisibility(e, true)}
                onBlur={(e) => this.setVisibility(e, false)}
                onTouchStart={(e) => this.setVisibility(e, true)}
                onTouchEnd={(e) => this.setVisibility(e, false)}
                ref={(el) => (this.wrapperElement = el)}
                tabIndex="0">
                {children}
                <TooltipPortal tooltipcontainer={tooltipcontainer}>
                    <div
                        data-testid="tooltip"
                        className={classnames(['kmx-tooltip', { 'kmx-tooltip--active': visible }])}
                        style={this.state.style}
                        ref={(el) => (this.tooltipElement = el)}>
                        <div className={'kmx-tooltip__content text-center kmx-typography--fine-print'}>{content}</div>
                    </div>
                </TooltipPortal>
            </span>
        );
    }
}

export default Tooltip;
